
(function($, undefined) { 
    var theme = { 
        init: function() { 
            this.initMobileMenu();
            this.initMegaMenu();
            this.initStickyMenu();
            this.initInstaFeed();
            this.initSmoothScroll();
            this.initSearch();
            this.initAccountForm();
            this.initProductsSlider();
            this.initLogosSlider();
            this.initFaqNav();
            this.initAjaxAddtoCart();
            this.initQuickShop();
            this.initProductPage();
            this.initCollectionFilter();
            this.initBundleCartAction();
            this.initCartPage();
            this.initQuantityAdjust();
            this.initNewsLetterForm();
            this.initGoCart();
            this.initHomeHeroSlider();
            this.initPromotionSlider();
            this.initFooterMenuCollapse();
            this.initTagMultifilter();
        },
        initMobileMenu: function() { 
            // Hamburger Animation
            $('body').on('click', '.js-toggle-hamburger', function() { 
              $(this).toggleClass('is-active');
              $('html').toggleClass('open-mobile__nav');
          })
        },
        initMegaMenu: function() {
            if ( $('.has-mega__menu').length ) { 
                // $('body').on('hover', '.mega-menu__items .child-menu__item', function() {
                $('.mega-menu__items .child-menu__item').hover(function() {
                    var $this   = $(this),
                        elem_id = $this.attr('id');

                    $('.mega-menu__wrapper').find(`.mega-menu__background`).removeClass('is-active');
                    if ( $('.mega-menu__wrapper').find(`#${elem_id}-bg`).length ) { 
                        $('.mega-menu__wrapper').find(`#${elem_id}-bg`).addClass('is-active');
                    } else { 
                        $('.mega-menu__wrapper').find(`.mega-menu__background`).eq(0).addClass('is-active');
                    }
                })
            }
        },
        initStickyMenu: function() { 
            var headerHeight = $('.site-header').height();
            $('.mobile-nav').css('top', headerHeight + 'px');
            $('.mobile-nav').css('height', `calc(100% - ${headerHeight}px)`);

            if ( $('body').hasClass('template-index') ) { 
                $('body').css('padding-top', headerHeight + 'px');

                $(window).on('scroll', function() { 
                    if ( $(window).width() > 767 ) { 
                        if ( $(window).scrollTop() > 200 ) { 
                            $('.component-announcement-bar').slideUp(100);
                            $('body').addClass('has-sticky__header');
                        } else { 
                            $('.component-announcement-bar').slideDown(100);
                            $('body').removeClass('has-sticky__header');
                        }
                    }
                });
            }
        },
        initInstaFeed: function() { 
            $('body')
            .on('click', '#insta-feed > a', function() { 
                $('body').addClass('open-instafeed');
            })
            .on('click', '#insta-feed .close-button a', function() { 
                $('body').removeClass('open-instafeed');
            })
        },
        initSmoothScroll: function() { 
            // Smooth Scroll Animation
            // var scroll = new SmoothScroll('a[href^="#"]');
            var scroll = new SmoothScroll('a[href^="#"]:not([href$="-insta-feed"])');
        },
        initSearch: function() { 
            // SEARCH 
            $('body')
            .on('click', '.js-show-search', function(e) { 
                e.preventDefault();
                e.stopPropagation();

                let $this = $(this),
                    $parent = $this.parent(),
                    $search_form = $parent.find('.menu-search__form');

                $search_form.addClass('is-active');
                $search_form.find('input').trigger('focus');
            })
            .on('click', function(e) { 
                if ( !$(e.target).closest('.menu-search__form').length && (!$(e.target).hasClass('ui-widget') || !$(e.target).closest('.ui-widget').length) ) { 
                    $('.menu-search__form').removeClass('is-active');
                }
            })
            /*
            .on('click', '.js-show-search, .search-close', function(e) { 
                e.stopPropagation();
                e.preventDefault();

                $('.search-close').css('padding-top', $('.header').height() + 100 + 'px');

                var $header = $('.index .header');

                if ( $('#search').is(':visible') && $(window).scrollTop() == 0 ) {
                    $header.removeClass('header_bar');
                    $header.find('.logo img').attr('src', $('.logo img').data('src-home'));
                } else {
                    $header.addClass('header_bar');
                    $header.find('.logo img').attr('src', $('.logo img').data('src'));
                }

                $('#search').fadeToggle('fast').find('input').focus();
            })
            */
        },
        initAccountForm: function() { 
            if ( $('.customer-login__section').length ) { 
                $('body')
                .on('click', '.customer-login__header .section-title', function(e) { 
                    if ( ! $(this).hasClass('is-active--title') ) { 
                        $('.customer-login__header .section-title').removeClass('is-active--title');
                        $(this).addClass('is-active--title');

                        var $form_tab = $('.customer-form__tab:not(.is-active--form)');
                        $('.customer-form__tab').removeClass('is-active--form');
                        $form_tab.addClass('is-active--form');
                    }
                })
            }
        },
        initProductsSlider: function() { 
            if ( $('.js-products--carousel').length ) { 
                $('.js-products--carousel').each(function() { 
                    var $this = $(this);
                    var products_per_row = parseInt($this.attr('data-products_per_row'));
                    if ( products_per_row == NaN ) { 
                        products_per_row = 3;
                    }

                    $this.on('init', function(event, slick, direction) {
                        $this.find('.slick-track').css('display', 'flex');
                    });

                    $this.on('afterChange', function(event, slick, direction) {
                        $this.find('.slick-track').css('display', 'flex');
                    });

                    $this.slick({ 
                        slidesToShow: products_per_row,
                        slidesToScroll: 1,
                        prevArrow: `<div class="slide-arrow__prev"><svg width="37" height="42" viewBox="0 0 37 42"><path d="M-0.000328839 -3.8458e-06L-0.000335693 41.9964L36.499 42L36.499 38.6028L29.1605 25.4734C27.5752 22.6374 27.5752 19.3675 29.1605 16.5314L36.499 3.40203L36.499 0.00484848L-0.000328839 -3.8458e-06Z" fill="black"/></svg> Prev</div>`,
                        nextArrow: `<div class="slide-arrow__next">Next <svg width="37" height="42" viewBox="0 0 37 42"><path d="M36.5 3.11894e-08L36.5 41.9971L0 42.0007L5.5444e-07 38.6035L7.33868 25.4739C8.92394 22.6378 8.92394 19.3678 7.33868 16.5317L6.29941e-06 3.40209L6.85385e-06 0.00484467L36.5 3.11894e-08Z" fill="black"/></svg></div>`,
                        responsive: [
                            {
                                breakpoint: 1250,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                })
            }
        },
        initLogosSlider: function() { 
            if ( $('.js-logos--carousel').length ) { 
                if ( $(window).width() <= 767 ) { 
                    $('.js-logos--carousel').each(function() { 
                        var $this = $(this);
                        var products_per_row = parseInt($this.attr('data-products_per_row'));
                        if ( products_per_row == NaN ) { 
                            products_per_row = 5;
                        }

                        if ( $this.hasClass('slick-initialized') ) { 
                            $this.slick('unslick');
                        }

                        $this.slick({ 
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            variableWidth: true,
                            centerMode: true,
                            /*responsive: [
                                {
                                    breakpoint: 900,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 500,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }
                            ]*/
                        })
                    })
                } else {
                    $('.js-logos--carousel').each(function() { 
                        var $this = $(this);
                        if ( $this.hasClass('slick-initialized') ) { 
                            $this.slick('unslick');
                        }
                    })
                }
            }
        },
        initFaqNav: function() { 
            if ( $('.faq-page__wrapper').length ) { 
                $('body')
                .on('click', '.faqs-category__wrapper a', function(e) { 
                    var $this = $(this),
                        $parent = $this.parent();
                    $parent.find('a').removeClass('is-active__cat');
                    $this.addClass('is-active__cat');

                    var faq_cat = $this.attr('data-cat');
                    $(`.faqs-category__list`).removeClass('is-active__cat');
                    $(`.faqs-category__list.faqs-${faq_cat}s__wrapper`).addClass('is-active__cat');

                    $('.faqs-category__selector').val(faq_cat);
                })
                .on('change', '.faqs-category__selector', function(e) {
                    var faq_cat = $(this).val();

                    $(`.faqs-category__wrapper a`).removeClass('is-active__cat');
                    $(`.faqs-category__wrapper a[data-cat="${faq_cat}"]`).addClass('is-active__cat');

                    $(`.faqs-category__list`).removeClass('is-active__cat');
                    $(`.faqs-category__list.faqs-${faq_cat}s__wrapper`).addClass('is-active__cat');
                })
            }
        },
        initAjaxAddtoCart: function() { 
            $('body').on('click', '.js-add-to-cart', function() { 
                var $this = $(this),
                    $parent = $this.parent();
                var p_id = parseInt($this.attr('data-variant-id'));
                var qty  = 1;

                if ( $parent.find(`[name="quantity"]`).length ) { 
                    qty = $parent.find(`[name="quantity"]`).val();
                }

                if ( $parent.find(`[name="id"]`).length ) { 
                    p_id = $parent.find(`[name="id"]`).val();
                }

                if ( p_id && qty ) { 
                    let formData = {
                        'items': [{
                            'id': p_id,
                            'quantity': qty
                        }]
                    };

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => {
                        if ( $('.js-go-cart-drawer').hasClass('is-open') ) { 
                            window.goCart.fetchCart();
                        } else { 
                            window.goCart.fetchAndOpenCart();
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            });
        },
        initQuickShop: function() { 
            $('body').on('click', '.js-quick-shop', function(e) { 
                e.preventDefault();

                var product_handle = $(this).attr('data-product-handle');
                if ( product_handle !== undefined ) { 
                    $.ajax({
                        url: `/products/${product_handle}?view=quickshop`,
                        dataType: "html"
                    })
                    .done(function(response) { 
                        var $container = $('#hidden-content #quickShop');
                        $container.empty();
                        $container.html(response);

                        // initSlider();
                        var $main_slider = $container.find('.product-image__slider');
                        var $nav_slider = $container.find('.product-thumbs__slider');
                        $main_slider.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                            fade: true,
                            asNavFor: '##quickShop .product-thumbs__slider'
                        })

                        $nav_slider.slick({
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            asNavFor: '##quickShop .product-image__slider',
                            arrows: false,
                            dots: false,
                            infinite: false
                        });

                        $.fancybox.open({
                            src  : '#hidden-content',
                            opts : {
                                afterShow : function( instance, current ) {
                                }
                            }
                        });
                    })
                }
            })
        },
        initProductPage: function() {
            if ( $(`[data-section="product"]`).length ) { 
                this.initProductImageSlider();
                this.initProductImageZoom();
                this.initProductRecommendations();

                $('body')
                .on('click', `.product--nutrition_ingredients .section-title`, function() { 
                    if ( $(window).width() <= 767 ) { 
                        var $this   = $(this),
                            $parent = $this.parent();

                        $parent.toggleClass('is-opened');
                        if ( $parent.hasClass('is-opened') ) { 
                            $parent.find('.product-nutrition__details, .product-ingredient__details').slideDown();
                        } else { 
                            $parent.find('.product-nutrition__details, .product-ingredient__details').slideUp();
                        }
                    }
                })
            }
        },
        initProductImageSlider: function() { 
            if ( $('.single-product__template .product-thumbs__slider').length ) { 
                $('.single-product__template .product-image__slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    fade: true,
                    asNavFor: '.single-product__template .product-thumbs__slider'
                })


                $('.single-product__template .product-thumbs__slider').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: '.single-product__template .product-image__slider',
                    arrows: false,
                    dots: false,
                    infinite: false,
                    focusOnSelect: true
                });
            }
        },
        initProductImageZoom: function() { 
            $('body').find('.product-image__slide').each(function() { 
                var $this   = $(this),
                    img_url = $this.find('img').attr('data-original-src');

                $this.zoom({
                    url: img_url
                });
            });
        },
        initProductRecommendations: function() { 
            // Look for an element with class 'product-recommendations'
            var productRecommendationsSection = document.querySelector(".product-recommendations");

            if (productRecommendationsSection === null) { return; }

            if ( productRecommendationsSection.dataset.isShaker == 'true' ) { 
                theme.initProductRecommendationsSlider();
                return;
            }

            var productId = productRecommendationsSection.dataset.productId;
            var baseUrl = productRecommendationsSection.dataset.baseUrl;
            var limit = productRecommendationsSection.dataset.limit;

            // Build request URL
            var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;

            // Create request and submit it using Ajax
            var request = new XMLHttpRequest();
            request.open("GET", requestUrl);
            request.onload = function() {
              if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;
                productRecommendationsSection.parentElement.innerHTML = container.querySelector("#shopify-section-product-recommendations").innerHTML;

                theme.initProductRecommendationsSlider();
              }
            };
            request.send();
        },
        initProductRecommendationsSlider: function() { 
            var $section = $('.product-recommendations .js-products--carousel');
            var products_per_row = parseInt($section.attr('data-products_per_row'));
            if ( products_per_row == NaN ) { 
                products_per_row = 3;
            }

            $section.on('init', function(event, slick, direction) {
                $section.find('.slick-track').css('display', 'flex');
            });

            $section.on('afterChange', function(event, slick, direction) {
                $section.find('.slick-track').css('display', 'flex');
            });

            $section.slick({ 
                slidesToShow: products_per_row,
                slidesToScroll: 1,
                prevArrow: `<div class="slide-arrow__prev"><svg width="37" height="42" viewBox="0 0 37 42"><path d="M-0.000328839 -3.8458e-06L-0.000335693 41.9964L36.499 42L36.499 38.6028L29.1605 25.4734C27.5752 22.6374 27.5752 19.3675 29.1605 16.5314L36.499 3.40203L36.499 0.00484848L-0.000328839 -3.8458e-06Z" fill="black"/></svg> Prev</div>`,
                nextArrow: `<div class="slide-arrow__next">Next <svg width="37" height="42" viewBox="0 0 37 42"><path d="M36.5 3.11894e-08L36.5 41.9971L0 42.0007L5.5444e-07 38.6035L7.33868 25.4739C8.92394 22.6378 8.92394 19.3678 7.33868 16.5317L6.29941e-06 3.40209L6.85385e-06 0.00484467L36.5 3.11894e-08Z" fill="black"/></svg></div>`,
                responsive: [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            })
        },
        initCollectionFilter: function() { 
            if ( $('.js-collection-filter').length ) { 
                $('body')
                .on('change', '.js-collection-filter select', function() { 
                    var $filterEle = $(this);
                    var filterURL  = $filterEle.find('option:selected').attr('data-url');

                    if ( $filterEle.hasClass('collection-type__filter') ) { 
                        $.ajax({
                            url: filterURL,
                            dataType: "html"
                        })
                        .done(function(response) { 
                            var $container = $('.collection-products__list');
                            $container.empty();

                            $container.html($(response).find('.collection-products__list').html());
                        })
                    } else if ( filterURL !== undefined ) { 
                        window.location.href = filterURL;
                    }
                })
                .on('click', '.js-clear--collection-filter', function() { 
                    $('.js-collection-filter select').val('all-type').trigger('change');
                })
            }
        },
        initBundleCartAction: function() { 
            if ( $('.bundle-cart__wrapper').length ) { 
                $('body')
                .on('click', '.js-add-to-bundle:not([disabled])', function() {
                    window.bundleContents = window.bundleContents || [];

                    if ( window.bundleContents.length < 5 ) { 
                        var $this        = $(this),
                            variant_id   = $this.attr('data-variant-id'),
                            product_type = $this.attr('data-product-type'),
                            image_url    = $this.closest('.collection-product__inner').find('.collection-product__img img').attr('src');

                        window.bundleContents.push({
                            id: variant_id,
                            type: product_type,
                            url: image_url
                        });

                        theme.renderBundleContents();
                    }
                })
                .on('click', '.js-remove-from-bundle', function() { 
                    var $this = $(this),
                        variant_id = $this.attr('data-id'),
                        data_index = $this.attr('data-index');

                    if ( data_index !== undefined ) { 
                        window.bundleContents.splice(data_index, 1);
                    } else { 
                        for (var i = 0; i < window.bundleContents.length; i++) {
                            if ( window.bundleContents[i].id == variant_id ) { 
                                window.bundleContents.splice(i, 1);
                                break;
                            }
                        }
                    }

                    theme.renderBundleContents();
                })
                .on('click', '.js-add-bundle-to-cart', function() { 
                    var is_valid_for_cart = false;
                    is_valid_for_cart = theme.checkValidBundleContents();

                    if ( is_valid_for_cart === true ) { 
                        let formData = {
                            'items': []
                        };

                        let bundleID = 'custom-bundle-' + Math.floor(Math.random() * 1000);

                        for (var i = 0; i < window.bundleContents.length; i++) {
                            formData.items.push({
                                id: window.bundleContents[i].id,
                                quantity: 1,
                                properties: {
                                    'bundle_id': bundleID
                                }
                            })
                        }

                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            if ( $('.js-go-cart-drawer').hasClass('is-open') ) { 
                                window.goCart.fetchCart();
                            } else { 
                                window.goCart.fetchAndOpenCart();
                            }

                            window.bundleContents = [];
                            theme.renderBundleContents();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    }
                })
            }
        },
        renderBundleContents: function() { 
            $('.bundle-cart__wrapper .bundle-cart__item').each(function() { 
                $(this).find('[data-bundle-image]').remove();
                $(this).find('.js-remove-from-bundle').remove();
            });

            if (window.bundleContents.length) { 
                if ( theme.checkValidBundleContents('sauce') == true ) { 
                    $('body').find(`.js-add-to-bundle[data-product-type="sauce"]`).attr('disabled', 'disabled');
                } else { 
                    $('body').find(`.js-add-to-bundle[data-product-type="sauce"]`).removeAttr('disabled');
                }

                if ( theme.checkValidBundleContents('rubs') == true ) { 
                    $('body').find(`.js-add-to-bundle[data-product-type="rubs"]`).attr('disabled', 'disabled');
                } else { 
                    $('body').find(`.js-add-to-bundle[data-product-type="rubs"]`).removeAttr('disabled');
                }

                if ( theme.checkValidBundleContents('chips') == true ) { 
                    $('body').find(`.js-add-to-bundle[data-product-type="chips"]`).attr('disabled', 'disabled');
                } else { 
                    $('body').find(`.js-add-to-bundle[data-product-type="chips"]`).removeAttr('disabled');
                }

                var sauces = 0;
                var rubs   = 0;
                var chips  = 0;

                for (var i = 0; i < window.bundleContents.length; i++) {
                    if ( window.bundleContents[i].type == 'sauce' ) { 
                        sauces++;

                        $(`.bundle-cart__wrapper .bundle-cart__item:nth-child(${sauces})`)
                        .append(`
                            <img src="${window.bundleContents[i].url}" data-bundle-image/>
                            <div class="js-remove-from-bundle" data-id="${window.bundleContents[i].id}" data-index="${i}">x</div>
                            `
                        );
                    } else if ( window.bundleContents[i].type == 'rubs' ) { 
                        rubs++;

                        $(`.bundle-cart__wrapper .bundle-cart__item:nth-child(${2 + rubs})`)
                        .append(`
                            <img src="${window.bundleContents[i].url}" data-bundle-image/>
                            <div class="js-remove-from-bundle" data-id="${window.bundleContents[i].id}" data-index="${i}">x</div>
                            `
                        );
                    } else if ( window.bundleContents[i].type == 'chips' ) { 
                        chips++;

                        $(`.bundle-cart__wrapper .bundle-cart__item:nth-child(${4 + chips})`)
                        .append(`
                            <img src="${window.bundleContents[i].url}" data-bundle-image/>
                            <div class="js-remove-from-bundle" data-id="${window.bundleContents[i].id}" data-index="${i}">x</div>
                            `
                        );
                    }

                    /*
                    $(`.bundle-cart__wrapper .bundle-cart__item[data-index=${i}]`)
                    .append(`
                        <img src="${window.bundleContents[i].url}" data-bundle-image/>
                        <div class="js-remove-from-bundle" data-id="${window.bundleContents[i].id}" data-index="${i}">x</div>
                        `
                    );
                    */
                }
            } else { 
                $('body').find(`.js-add-to-bundle[data-product-type="sauce"]`).removeAttr('disabled');
                $('body').find(`.js-add-to-bundle[data-product-type="rubs"]`).removeAttr('disabled');
                $('body').find(`.js-add-to-bundle[data-product-type="chips"]`).removeAttr('disabled');
            }
        },
        checkValidBundleContents: function(product_type = undefined) { 
            window.bundleContents = window.bundleContents || [];

            var sauces = 0;
            var rubs   = 0;
            var chips  = 0;

            for (var i = 0; i < window.bundleContents.length; i++) {
                if ( window.bundleContents[i].type == 'sauce' ) { 
                    sauces++;
                } else if ( window.bundleContents[i].type == 'rubs' ) { 
                    rubs++;
                } else if ( window.bundleContents[i].type == 'chips' ) { 
                    chips++;
                }
            }

            if ( product_type != undefined ) { 
                if ( product_type == 'sauce' && sauces != 2 ) { 
                    return false;
                }

                if ( product_type == 'rubs' && rubs != 2 ) { 
                    return false;
                }

                if ( product_type == 'chips' && chips != 1 ) { 
                    return false;
                }

                return true;
            }

            if ( sauces != 2 || rubs != 2 || chips != 1 ) { 
                return false;
            }

            /*
            if ( sauces < 2 ) { 
                return false;
            }
            */

            return true;
        },
        initCartPage: function() {
            if ( $('.cart-page__wrapper').length ) { 
                $('body')
                .on('click', '.js-cart-qty-wrap span', function() { 
                    var $this    = $(this),
                        $parent  = $this.parent(),
                        $inputEl = $parent.find('input'),
                        qty      = parseInt($inputEl.val());

                    if ( $this.hasClass('plus') ) { 
                        $inputEl.val(++qty);
                    } else {
                        $inputEl.val(--qty);
                    }

                    $('.js-update-cart').trigger('click');
                })
                .on('click', '.js-cart__remove-bundle', function(e) { 
                    e.preventDefault();

                    var $this = $(this),
                        $cart_item = $this.closest('.cart__row');

                    $cart_item.hide();
                    var updates = $this.attr('href').replace('/cart/update?', '');
                    console.log(updates);

                    window.fetch('/cart/update.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: updates,
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((response) => response.json())
                    .then(() => window.location.href= '/cart')
                    .catch((error) => {
                        console.log(error);
                    });
                })
            }
        },
        initQuantityAdjust: function() {
            /* JS Quantity Incrementers */
            $('body')
            .on('click', '.js-qty-wrap span', function() { 
                var $this    = $(this),
                    $parent  = $this.parent(),
                    $inputEl = $parent.find('input'),
                    qty      = parseInt($inputEl.val());

                if ( $this.hasClass('plus') ) { 
                    $inputEl.val(++qty);
                } else {
                    if ( qty > 1 ) { 
                        $inputEl.val(--qty);
                    }
                }
            })
        },
        initNewsLetterForm: function() { 
            $('.subscribe-button').prop("disabled", false);
            $('body').on('click', 'input:checkbox.checks', function() { 
                if ($(this).is(':checked')) {
                    $('.subscribe-button').prop("disabled", true);
                } else {
                    if ($('.checks').filter(':checked').length < 1){
                        $('.subscribe-button').attr('disabled', false);
                    }
                }
            });
        },
        initGoCart: function() { 
            /*
            window.goCart = new GoCart({
                cartMode: window.goCartConfig.cartMode,   // drawer or mini-cart  
                drawerDirection: window.goCartConfig.drawerDirection,   // cart drawer from left or right
                displayModal: window.goCartConfig.displayModal,   // display success modal when adding product to cart
                moneyFormat: window.goCartConfig.moneyFormat,   // template for money format when displaying money
            });
            */
        },
		initHomeHeroSlider: function() { 
            if ( $('.template-index .js-home-hero-slider').length ) { 
                $('.template-index .js-home-hero-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    fade: true,
	                autoPlay: true,
                    autoplaySpeed: 2500,
                    appendArrows: '.home-hero-slick-arrow-wrapper',
                    prevArrow: '<div class="slide-arrow__prev slick-arrow" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
                    nextArrow: '<div class="slide-arrow__next slick-arrow" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
                });
            }
        },
        initPromotionSlider: function() { 
            if ( $('.template-index .js-home-promotion-carousel').length ) { 
                $('.template-index .js-home-promotion-carousel').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    fade: true,
                    appendArrows: '.slick-arrow-wrapper',
                    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">&lt;</button>',
                    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">></button>',
                });
            }
        },
        initFooterMenuCollapse: function() { 
            $('body').on('click', '.footer-top__section .footer-nav__title', function() { 
                if ( $(window).width() <= 767 ) { 
                    var $this   = $(this),
                        $parent = $this.parent();

                    $parent.toggleClass('is-opened');
                    if ( $parent.hasClass('is-opened') ) { 
                        $parent.find('.footer-nav__menu').slideDown();
                    } else { 
                        $parent.find('.footer-nav__menu').slideUp();
                    }
                }
            })
        },
        initTagMultifilter: function() { 
            if ( $('.template-collection .js_multifilter-container').length ) { 
              var $filterObject = $('.js_multifilter-container .js_multifilter-item');
              var $filterTrigger = $('*[data-filterby]');
              var $filterTriggerAll = $('*[data-filterby="all"]');
              var $filterNoResults = $('.js_multifilter-noresults');
              var activeFilters = [];
              var activeClasses = '';
              var spacerHeight;

              $(window).on('resize',function() {
                  var spacerHeightDesktopOffset = 50;
                  var windowWidth = $(window).width();
                  if (windowWidth > 991) {
                    //console.log("DESKTOP");
                    var spacerHeight = ( $('.js_collection-subfilters').outerHeight() );
                    var spacerHeight = spacerHeight + spacerHeightDesktopOffset;
                  } else {
                    console.log("NOT DESKTOP")
                    var spacerHeight = $('.js_collection-subfilters').outerHeight();
                  }
                  console.log("spacerHeight = " + spacerHeight);
                  $(".js_collection-subfilters__spacer").height(spacerHeight);
                  $(".js_collection-header").css("margin-bottom", "-"+spacerHeight+"px");
              }).trigger('resize');
              

              // set spacer height equal to filter height
              
              function checkArray(){
                activeClasses = "." + activeFilters.join(".");           
                if ( activeFilters.length > 0) { 
                   $filterObject.each(function() {          
                      if ( $(this).is(activeClasses) ) {
                        $(this).show();
                      } else {
                        $(this).hide();
                      }
                    });
                    newLayout();
                } else {
                  filterOnAll();
                }                
              };
              function filterOnAll(){
                $filterTrigger.removeClass('active');
                $filterTriggerAll.addClass('active');
                activeFilters = [];
                var activeClasses = '';
                $filterObject.show();
                newLayout();
              };
              function filterOn(passedFilterClass){
                activeFilters.push(passedFilterClass);
                $filterTriggerAll.removeClass('active');
                checkArray();
               };
              function filterOff(passedFilterClass){
                $('*[data-filterby="' + passedFilterClass + '"]').removeClass('active');
                activeFilters = activeFilters.filter(e => e !== passedFilterClass); 
                checkArray();
               };
              function newLayout(){
                // no results message
                if ( ! $filterObject.is(":visible") ){
                  $filterNoResults.show();
                } else {
                  $filterNoResults.hide();
                }
                // borders:
                $filterObject.removeClass('no-border-992 no-border-1200');
                $('.js_multifilter-container .js_multifilter-item:visible').each(function(i) { 
                  if (i === 0) $(this).addClass('no-border-992 no-border-1200');
                  if (i % 2 === 0) $(this).addClass('no-border-992');
                  if (i % 2 === 0) $(this).addClass('no-border-1200');                  
                });
              };
              
              // turn on ALL at init
              filterOnAll();
              
              $filterTrigger.click(function() {
                var filterClass = $(this).attr('data-filterby');
                // ALL FILTERS EXCEPT ALL
                if (filterClass != 'all'){ 
                  if ( $(this).hasClass('active') ) {
                    filterOff(filterClass);
                  } else {
                    $(this).addClass('active');
                    filterOn(filterClass);
                  }
                // ALL FILTER
                } else {
                  if (! $(this).hasClass('active') ) {
                    filterOnAll();
                  }
                }
              });
          }
        }
    };

    $(document).ready(function() { 
        theme.init();
    })

    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            theme.initProductRecommendations();
        }
    });
})(window.jQuery);